import React from 'react';
import { ScheduleCallRoute } from '@weave/schema-gen-ts/dist/schemas/phone/callroute/v1/callroute_service.pb';
import { useTranslation } from '@frontend/i18n';
import { usePhoneSettingsShallowStore } from '@frontend/phone-config';
import { useAppScopeStore } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { Text, Chip } from '@frontend/design-system';
import { CallRoutesLink } from './call-routes-link';

interface TraySubHeaderProps {
  scheduleCallRoutes?: ScheduleCallRoute[];
  selectedLocationId?: string;
  routeType?: 'callRoute' | 'deviceRoute';
}

export const TraySubHeader: React.FC<TraySubHeaderProps> = ({
  scheduleCallRoutes,
  selectedLocationId,
  routeType = 'callRoute',
}) => {
  const { t } = useTranslation('phone');
  const { settingsTenantLocation } = usePhoneSettingsShallowStore('settingsTenantLocation');
  const isUnify = settingsTenantLocation?.locationType === 'unify';
  const { getScopeName } = useAppScopeStore();

  return (
    <div
      css={{
        display: 'flex',
        gap: theme.spacing(9),
        borderBottom: `1px solid ${theme.colors.neutral20}`,
        paddingBottom: theme.spacing(2),
      }}
    >
      {scheduleCallRoutes && (
        <div>
          <Text color='light' size='medium'>
            {routeType === 'deviceRoute' ? t('Device Route') : t('Call Route')}
          </Text>
          <CallRoutesLink scheduleCallRoutes={scheduleCallRoutes} />
        </div>
      )}
      {isUnify && (
        <div>
          <Text color='light' size='medium'>
            {t('Location')}
          </Text>
          {selectedLocationId && <Chip.SingleChip>{getScopeName(selectedLocationId ?? '')}</Chip.SingleChip>}
        </div>
      )}
    </div>
  );
};
